import React from "react";
import { Card } from "@chakra-ui/react";
import shadows from "@mui/material/styles/shadows";
const Home1 = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  const role = user?.role; // use optional chaining to avoid crashes
  console.log(role);

  return (
    <>
      <div className="relative isolate">
        <div className="relative top-0 inline-block w-full">
          <img
            src="/girl-earth-bg.png"
            alt="Mindfulness"
            className="w-full h-auto object-cover"
          />

          <div className="absolute top-[18%] left-1/2 -translate-x-1/2 text-center z-20 md:top-[16%]">
            <h1
              className="text-5xl md:text-6xl font-extrabold tracking-wide drop-shadow-sm "
              style={{ color: "#9a4a4a" }} // darker peach-brown
            >
              HappyU
            </h1>
            <p
              className="text-lg font-medium mt-4 drop-shadow-sm"
              style={{ color: "#b36b6b" }}
            >
              Your Wellness Space
            </p>
          </div>


          <div
            className="
      md:relative lg:absolute
      lg:inset-0 
      flex flex-col items-center justify-center
      text-center
      px-6 py-12 lg:py-0
      lg:bg-transparent
      md:bg-lightCream
      bg-lightCream
    "
          >
            <div className="max-w-2xl ">
              <h1 className=" text-3xl lg:text-4xl md:text-3xl  font-bold tracking-tight text-gray-900" style={{ color: "#9a4a4a" }}>
                Welcome to Mindfulness
              </h1>

              <p className="mt-6 lg:text-lg md:text-lg  sm:text-xl leading-8 text-gray-700" style={{ color: "#b36b6b" }}>
                Welcome to our mental health app, where you can anonymously
                chat, track your mood, and receive personalized support through
                quizzes and an AI assistant. Prioritize your emotional
                well-being discreetly and effectively with our compassionate
                community
              </p>

              <div className="mt-10 flex items-center justify-center gap-x-6  ">
                <div
                  aria-hidden="true"
                  className=" rounded-md  hover:rounded-md px-2 hover:scale-110 transition-all duration-500 ease-in-out"
                >
                  {role &&
                    (role === "counsellor" ? (
                      <Card
                        bg="#ffe6df"
                        as="a"
                        shadow={shadows[0]}
                        
                        href={`/${user?.username}/counsellorappointments`}
                        className="max-w-sm mx-auto p-2 px-4 cursor-pointer rounded-3xl shadow-none"
                      >
                        <div className="flex items-center gap-4">
                          <div>
                            <h1 className="text-lg font-semibold text-gray-900" style={{ color: "#9a4a4a" }}>
                              Pending Appointments →
                            </h1>
                          </div>
                        </div>
                      </Card>
                    ) : (
                      <Card
                        bg="#ffe6df"
                        as="a"
                        shadow={shadows[0]}
                        href={`/${user?.username}/appointments`}
                        className="max-w-sm mx-auto p-3 px-4 cursor-pointer  rounded-3xl shadow-none"
                      >
                        <div className="flex items-center gap-4">
                          <div>
                            <h1 className="text-lg font-semibold text-gray-900" style={{ color: "#9a4a4a" }}>
                              Your Appointments →
                            </h1>
                          </div>
                        </div>
                      </Card>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home1;
